import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { createEntity, filterEntities } from "../../../apis/apiService";
import { toast } from "react-toastify";
import { FaClock, FaPause, FaPlay, FaStop } from "react-icons/fa6";
import { PauseNoteModal, StopTimerModal } from "./TimerPopup";
import dayjs from "dayjs";

const CommonDetailTimer = ({
  user_id,
  task_id,
  project_id,
  isIssueDetail,
  issue_id,
}) => {
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  const login_user_role = login_user?.role;
  const [showPauseModal, setShowPauseModal] = useState(false);
  // const [showStopModal, setShowStopModal] = useState(false);
  const [showStopModal, setShowStopModal] = useState(
    localStorage.getItem("showStopModalPending") === "true"
  );
  const [showTimers, setShowTimers] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [getTimers, setGetTimers] = useState([]);
  const [secondsElapsed, setSecondsElapsed] = useState(0);
  const intervalRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const [getTimerId, setGetTimerId] = useState(
    localStorage.getItem("timer_id")
  );
  const [timerDatas, setTimerDatas] = useState();
  const formatTime = (totalSeconds) => {
    const hrs = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
    const mins = String(Math.floor((totalSeconds % 3600) / 60)).padStart(
      2,
      "0"
    );
    const secs = String(totalSeconds % 60).padStart(2, "0");
    return `${hrs}:${mins}:${secs}`;
  };

  const getTimer = async () => {
    if (
      !project_id ||
      project_id === "undefined" ||
      ((!task_id || task_id === "undefined") &&
        (!issue_id || issue_id === "undefined"))
    )
      return;
    try {
      const requestedData = {
        user_id: user_id,

        project_id: project_id,
        log_date: dayjs().format("YYYY-MM-DD"),
      };
      isIssueDetail
        ? (requestedData.issue_id = issue_id)
        : (requestedData.task_id = task_id);
      const getTimerResponse = await filterEntities("timer/get", requestedData);
      localStorage.setItem("timer_id", getTimerResponse.timer_id);
      setGetTimerId(getTimerResponse.timer_id);
      if (getTimerResponse?.total_seconds != null) {
        setSecondsElapsed(getTimerResponse.total_seconds); // Always update time
      }
      setGetTimers(getTimerResponse); // Always update timer state

      if (getTimerResponse?.running && getTimerResponse?.status === "STARTED") {
        setShowTimers(true);
        setIsPaused(false);
      }

      if (!getTimerResponse?.running && getTimerResponse?.status === "PAUSED") {
        setShowTimers(true);
        setIsPaused(true);
      }

      if (!getTimerResponse?.running && getTimerResponse?.status == null) {
        setShowTimers(false);
      }
    } catch (err) {
      if (login_user_role !== "CLIENT") {
        toast.error(err.message);
      }
    }
  };

  useEffect(() => {
    if (
      project_id &&
      project_id !== "undefined" &&
      ((task_id && task_id !== "undefined") ||
        (issue_id && issue_id !== "undefined"))
    ) {
      getTimer();
    }

    return () => clearInterval(intervalRef.current); // Cleanup on unmount
  }, [task_id, issue_id, project_id]);
  useEffect(() => {
    const stopModalPending =
      localStorage.getItem("showStopModalPending") === "true";
    const timerDataFromStorage = JSON.parse(localStorage.getItem("timer_data"));
    const storedTimerId = localStorage.getItem("timer_id");

    if (stopModalPending && timerDataFromStorage) {
      setTimerDatas(timerDataFromStorage);
      setShowStopModal(true);

      // ✅ Restore timer_id if not already set
      if (!getTimerId && storedTimerId) {
        setGetTimerId(storedTimerId);
      }
    }
  }, []);

  useEffect(() => {
    if (getTimers?.running && !isPaused) {
      intervalRef.current = setInterval(() => {
        setSecondsElapsed((prev) => prev + 1);
      }, 1000);
    }

    return () => clearInterval(intervalRef.current); // Clear on pause or stop
  }, [getTimers, isPaused, getTimer]);

  const handleStartTimer = async () => {
    setLoading(true);

    const requestedData = {
      // task_id: task_id,
      project_id: project_id,
      log_date: dayjs().format("YYYY-MM-DD"),
    };
    isIssueDetail
      ? (requestedData.issue_id = issue_id)
      : (requestedData.task_id = task_id);
    try {
      const response = await createEntity("timer/start", requestedData);
      if (response) {
        await getTimer();
        toast.success(response.message);
      }
    } 
    catch (err) {
      toast.error(err.message);
    } 
    finally {
      setLoading(false);
    }
  };

  const handlePauseClick = () => {
    setShowPauseModal(true);
  };

  const handleResumeTimer = async () => {
    setLoading(true);
    const requestedData = {
      // user_id: login_user_id,
      // task_id: id,
      // project_id: project_id,
      // log_date: dayjs().format("YYYY-MM-DD"),
      timer_id: getTimerId,
      // notes: note,
    };

    try {
      const response = await createEntity("timer/resume", requestedData);
      if (response.data.status === "STARTED") {
        toast.success(response.message);
        // setIsPaused(false);
        // setShowTimers(true);
        await getTimer();
      }
    } 
    catch (err) {
      toast.error(err.message);
    } 
    finally {
      setLoading(false);
    }
  };

  const handleStopTimer = async () => {
    setLoading(true);
    const requestedData = {
      timer_id: getTimerId,
    };
    try {
      const response = await createEntity("timer/stop", requestedData);
      toast.success(response.message);
      if (response) {
        // setTimerDatas(response.data);
        // localStorage.setItem("timer_data", JSON.stringify(response.data));
        // localStorage.setItem("showStopModalPending", "true");
        // setShowStopModal(true);
        // setTimerDatas(response.data);
        const timerData = response.data;
        localStorage.setItem("timer_data", JSON.stringify(timerData));
        localStorage.setItem("new_timer_id", timerData.timer_id);
        localStorage.setItem("showStopModalPending", "true");

        setTimerDatas(timerData);
        setShowStopModal(true);
        clearInterval(intervalRef.current);
        setShowTimers(false);
        setIsPaused(false);
      }
    } 
    catch (err) {
      toast.error(err.message);
    } 
    finally {
      setLoading(false);
    }
  };

  const handleUpdatePauseNote = async (note) => {
    setLoading(true);
    const requestedData = {
      // user_id: login_user_id,
      // task_id: id,
      // project_id: project_id,
      // log_date: dayjs().format("YYYY-MM-DD"),
      timer_id: getTimerId,
      notes: note,
    };
    try {
      const response = await createEntity("timer/pause", requestedData);
      toast.success(response.message);
      if (response.data.status === "PAUSED") {
        setShowPauseModal(false);
        // setIsPaused(true);
        await getTimer();
        // setShowTimers(true);
      }
    } 
    catch (err) {
      toast.error(err.message);
    } 
    finally {
      setLoading(false);
    }
    // Pause timer logic here
  };

  return (
    <>
      <div className="ps-3 d-flex align-items-center gap-2 ">
        {!showTimers && (
          <FaClock
            className="text-rgbr-blue me-1  "
            onClick={!loading ? handleStartTimer : undefined}
            style={{ cursor: loading ? "not-allowed" : "pointer" }}
            title="Start  Timer"
          />
        )}

        {showTimers && (
          <div className=" d-flex align-items-center gap-2">
            <lable className="text-rgba-gray ">
              {" "}
              {formatTime(secondsElapsed)}
            </lable>
            {!isPaused && (
              <FaPause
                className="text-warning me-1"
                onClick={!loading ? handlePauseClick : undefined}
                style={{ cursor: loading ? "not-allowed" : "pointer" }}
                title="Pause Timer"
              />
            )}

            {isPaused && (
              <FaPlay
                className="text-success me-1"
                onClick={!loading ? handleResumeTimer : undefined}
                style={{ cursor: loading ? "not-allowed" : "pointer" }}
                title="Resume Timer"
              />
            )}
            
            <FaStop
              className="text-danger me-1"
              onClick={!loading ? handleStopTimer : undefined}
              style={{ cursor: loading ? "not-allowed" : "pointer" }}
              title="Stop Timer"
            />
          </div>
        )}
      </div>
      
      <PauseNoteModal
        show={showPauseModal}
        onClose={() => setShowPauseModal(false)}
        onUpdate={handleUpdatePauseNote}
        loading={loading}
      />
      <StopTimerModal
        show={showStopModal}
        onClose={() => {
          localStorage.removeItem("showStopModalPending");
          setShowStopModal(false);
        }}
        setShowTimers={setShowTimers}
        login_user_id={user_id}
        timerDatas={timerDatas}
        loading={loading}
        getTimer={getTimer}
        task_id={task_id}
        issue_id={issue_id}
        timer_id={getTimerId}
        project_id={project_id}
      />
    </>
  );
};
export default CommonDetailTimer;
